import { AllocationName } from ".";
import {
  FutureIncomeResponse,
  ScenarioCoefficientsGrouping,
  ScenarioCoefficientsGroupingEntry,
  ScenarioValuesGrouping,
  ScenarioValuesGroupingEntry,
} from "../../../../generated-api-v3";

const impactCategories = ["Price", "Yield", "Fx", "Volatility"];

const categoriesDict: Partial<
  Record<AllocationName, keyof FutureIncomeResponse>
> = {
  Sector: "sectors",
  Country: "countries",
  Currency: "currencies",
  "Asset Class": "assets",
};

export function handleAllocationScenario(
  allocations:
    | ScenarioValuesGrouping
    | ScenarioCoefficientsGrouping
    | undefined,
  requiresApiValues: boolean,
  targetCategory: AllocationName,
  options: {
    colors?: string[];
    priceMultiplier: number;
    fxMultiplier: number;
    yieldMultiplier: number;
    volatilityMultiplier: number;
  },
  incomeData: FutureIncomeResponse | undefined
) {
  const categoryMap = new Map<string, Grouping[]>();
  const allocationMap = new Map<
    string,
    ScenarioValuesGrouping | ScenarioCoefficientsGrouping
  >();
  if (!allocations && !incomeData) return { categoryMap, allocationMap };
  const entries = allocations?.entries;
  let grouping: Grouping[] = [];

  const colors = options.colors ?? ["blue", "green", "orange", "red"];

  // let's say impactCategories is [Sector, Country, Currency]
  // and colors are [red, green blue]
  [
    [0, "priceMultiplier", options.priceMultiplier, "priceValue"],
    [1, "yieldMultiplier", options.yieldMultiplier, "yieldValue"],
    [2, "fxMultiplier", options.fxMultiplier, "fxValue"],
    [
      3,
      "volatilityMultiplier",
      options.volatilityMultiplier,
      "volatilityValue",
    ],
  ].forEach((x) => {
    const [index, itemKey, sliderMultiplier, alternateValue] = x;

    grouping = grouping.concat(
      (entries || []).map((item) => {
        const val = requiresApiValues
          ? (item as any)[alternateValue]
          : ((item as any)[itemKey] ?? 0) * (sliderMultiplier as number);

        return {
          value: val,
          name: item.name,
          category: impactCategories[index as number],
          id: impactCategories[index as number],
          color: colors[index as number],
          item,
        };
      })
    );
  });

  if (incomeData && targetCategory in categoriesDict) {
    const income = incomeData[categoriesDict[targetCategory]!].map((item) => ({
      value: item.amountBase,
      name: item.name,
      category: "Income",
      id: "Income",
      color: "#e56af1",
      item: item as any,
    }));

    grouping.push(...income);
  }
  categoryMap.set(targetCategory, grouping);
  allocationMap.set(targetCategory, allocations);

  return { categoryMap, allocationMap };
}

type Grouping = {
  value: number;
  name: string;
  category: typeof impactCategories[number];
  id: typeof impactCategories[number];
  color: string;
  item: ScenarioValuesGroupingEntry | ScenarioCoefficientsGroupingEntry;
};
